import {
  useAuthorisedEntities,
  useSelectedLp,
} from '@amzn/carrierlogistics-commons/dist/hooks/authorisation/index';
import { isEmpty } from 'lodash';
import { useIntl } from 'react-intl';
import { sideNavItemsExternal } from '../config/sideMenuNavItems';
import { AUTHORIZATION } from '../constants/authorization';

export const useSideNavItems = () => {
  const authorizedEntities = useAuthorisedEntities();
  const lpSelected = useSelectedLp();
  const { formatMessage } = useIntl();

  const entitiesWithPermissions = sideNavItemsExternal.map(({ ...config }) => {
    const label = formatMessage({ id: config.label });
    let { childNodes } = config;
    let hasAuthorizedChild = false;
    if (childNodes) {
      childNodes = childNodes.map((node) => {
        const formattedLabel = formatMessage({ id: node.label });
        const isChildAuthorized = authorizedEntities?.[node.pamPermKey]?.length
        && authorizedEntities?.[lpSelected.lpId]?.includes(AUTHORIZATION.ACCESS);

        hasAuthorizedChild = isChildAuthorized ? true : hasAuthorizedChild;
        return {
          ...node,
          label: formattedLabel,
          isAuthorized: isChildAuthorized,
        };
      });
    }
    if (isEmpty(lpSelected)) return { isAuthorized: false, ...config, label };
    const isAuthorized = (authorizedEntities?.[config.pamPermKey]?.length
      && authorizedEntities?.[lpSelected.lpId]?.includes(AUTHORIZATION.ACCESS))
       || hasAuthorizedChild;
    return {
      isAuthorized, ...config, label, childNodes,
    };
  });
  const HOME_PAGE_CONFIGURATION_UNMODIFIED = sideNavItemsExternal[0];
  entitiesWithPermissions[0] = {
    ...HOME_PAGE_CONFIGURATION_UNMODIFIED,
    label: formatMessage({ id: HOME_PAGE_CONFIGURATION_UNMODIFIED.label }),
  };
  // The first item in sidebar is Home, which doesnt have permissions
  return entitiesWithPermissions;
};

export default useSideNavItems;
